import React from 'react';
import {motion} from 'framer-motion';
import {styled} from "@mui/material/styles";
import "./style.scss";
import SimpleSpinner from "@/components/spinner/simpleSpinner";

const Loader = styled(motion.div)(() => ({
    backgroundColor: '#eee',
    width: '100vw',
    height: '100vh',
    position: 'fixed',
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    color: 'black',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
}));

const Spinner: React.FC = () => {
    return (
        <Loader>

            <SimpleSpinner/>
        </Loader>
    )
}

export default Spinner;
